import axios from '~/common/plugins/axios.js'
// 该store仅提供搜索参数的缓存和读取
export const state = () => ({
  searchTabNow: '0', // 0-型号 1-人脉 2-文章
  searchKey: null
});

export const mutations = {
  set_searchKey(state, v) {
    state.searchKey = v;
  },
  set_searchTabNow(state, v) {
    state.searchTabNow = v;
  }
};
export default {
	namespaced: true,
	state,
	mutations
}
